import { render, staticRenderFns } from "./SitesNewRegistration.vue?vue&type=template&id=6ff50b04&"
import script from "./SitesNewRegistration.vue?vue&type=script&lang=js&"
export * from "./SitesNewRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports